/**
 * AlertHistoryLog — scrollable log of past alerts with severity + channel info.
 */
import React from 'react';
import { fmtTime } from '../../squareDashboardUtils';
import { SEVERITY_META } from './AnomalyFeed';

export default function AlertHistoryLog({ alertHistory }) {
  if (!alertHistory || alertHistory.length === 0) return null;
  return (
    <div className="ai__section">
      <div className="ai__section-title">📋 Alert History (Last 50)</div>
      <div className="ai__alert-log">
        {alertHistory.map((a, i) => {
          const meta = SEVERITY_META[a.severity] || SEVERITY_META.low;
          return (
            <div key={i} className="ai__alert-row">
              <span className="ai__alert-dot">{meta.dot}</span>
              <span className="ai__alert-time">{fmtTime(a.timestamp)}</span>
              <span className="ai__alert-title">{a.title}</span>
              {a.channel && a.channel !== 'pending' && (
                <span className={`ai__alert-channel ai__alert-channel--${a.channel.includes('sms') ? 'sms' : a.channel.includes('fcm') ? 'fcm' : 'fail'}`}>
                  {a.channel.includes('sms') ? '💬 SMS' : a.channel === 'fcm' ? '📲 Push' : '⚠️'}
                </span>
              )}
              <span className="ai__alert-body">{a.body}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
